import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@godaddy/react-mintl';
import Link from '@ux/link';

const InboxLinks = ({ urls, appEid }) => {
  const { formatMessage } = useIntl();

  const pageEid = appEid.extend('inbox_links');

  const messages = {
    inboxLinksHeading:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:InboxLinks:Heading' }),
    o365Login:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:InboxLinks:O365Login' }),
    webmailLogin:
      formatMessage({ id: 'Shared:AccountTray:QuickLinks:InboxLinks:WebmailLogin' })
  };

  return (
    <div className='account-info-section'>
      <div className='account-info-title'>
        <span> { messages.inboxLinksHeading }</span>
      </div>
      <Link
        className='customer-link-component'
        href={ urls.sso.o365Login.href }
        data-eid={ pageEid('O365_signin.link.click') }
        aria-label={ messages.o365Login }>
        <span> { messages.o365Login }</span>
      </Link>
      <Link
        className='customer-link-component'
        href={ urls.webmailLogin.href }
        data-eid={ pageEid('GD_email_signin.link.click') }
        aria-label={ messages.webmailLogin }>
        <span>{ messages.webmailLogin }</span>
      </Link>
    </div>
  );
};

InboxLinks.propTypes = {
  urls: PropTypes.object.isRequired,
  appEid: PropTypes.func
};

export default InboxLinks;
